import { render } from "./FinishQuizDialog.vue?vue&type=template&id=6ccf9a38&scoped=true&bindings={\"marks\":\"props\",\"playAgain\":\"setup\"}"
import script from "./FinishQuizDialog.vue?vue&type=script&lang=js"
export * from "./FinishQuizDialog.vue?vue&type=script&lang=js"

import "./FinishQuizDialog.vue?vue&type=style&index=0&id=6ccf9a38&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6ccf9a38"

export default script